import { CircleFlag } from "react-circle-flags";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

import { toggleLanguage } from "@/lib/utils";

import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

export function AuthLayout() {
  const { i18n } = useTranslation();

  return (
    <main className="relative flex h-screen items-center justify-center bg-neutral-800 text-white">
      <div className="absolute right-4 top-4">
        <Tooltip>
          <TooltipTrigger asChild>
            <button onClick={() => toggleLanguage(i18n)} type="button">
              {i18n.language === "en-US" ? <CircleFlag countryCode="fr" className="size-7 rounded-full border-2 border-white" /> : <CircleFlag countryCode="gb" className="size-7 rounded-full border-2 border-white" />}
            </button>
          </TooltipTrigger>
          <TooltipContent>
            {i18n.language === "en-US" ? "Switch to French" : "Switch to English"}
          </TooltipContent>
        </Tooltip>
      </div>
      <Outlet />
    </main>
  );
}
